import React, { FC } from "react";
import Decimal from "decimal.js";

export type ShowNativeProps = {
    amount: Decimal;
};

export const ShowNative: FC<ShowNativeProps> = ({ amount }) => {
    return (
        <div className="flex flex-col items-center justify-center px-6 py-4 rounded-2xl border border-orange-300 shadow-[0_0_25px_rgba(253,186,116,0.25)] backdrop-blur-sm bg-gradient-to-br from-orange-50/30 via-orange-100/10 to-transparent">
            <div className="text uppercase tracking-widest text-orange-400 mb-1">
                Balance
            </div>
            <div className="text-5xl font-black text-orange-300">
                {amount.toFixed(4).toLocaleString()} <span className="text-orange-400">SOL</span>
            </div>
        </div>
    );
};